var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    height: "32px",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#208CA4",
    d: "M14.436,18.655v8.665c0,0.677-0.549,1.226-1.227,1.226s-1.227-0.548-1.227-1.226v-5.707l-9.891,9.891  c-0.238,0.239-0.553,0.359-0.867,0.359c-0.313,0-0.625-0.12-0.865-0.359c-0.479-0.479-0.479-1.254,0-1.733l9.891-9.892H4.543  c-0.678,0-1.227-0.548-1.227-1.225c0-0.676,0.549-1.226,1.227-1.226h8.666C13.887,17.43,14.436,17.979,14.436,18.655z M31.641,0.495  c-0.477-0.479-1.252-0.479-1.732,0L19.883,10.522V4.815c0-0.677-0.549-1.225-1.227-1.225c-0.676,0-1.225,0.548-1.225,1.225v8.665  c0,0.677,0.549,1.226,1.225,1.226h8.664c0.678,0,1.227-0.549,1.227-1.226s-0.549-1.225-1.227-1.225h-5.705L31.641,2.229  C32.119,1.75,32.119,0.975,31.641,0.495z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/collapse-all.e87f4082471fec5dba3f29b02bb36d9b.svg";
export { ForwardRef as ReactComponent };